var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.visible)?_c('div',{staticClass:"watermark-container",style:(_vm.containerStyle),attrs:{"id":_vm.containerId}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }